import type { ReactElement } from 'react';
import { SongList } from 'components';
import Checkout from 'components/Checkout';
import { FiltersLayout } from 'layouts';
import { useSongsStore } from 'services/hooks';
import useStyles from './style';

const MainSongList = (): ReactElement => {
  const classes = useStyles();

  const { songsStore, isGetSongsLoading } = useSongsStore();
  const { ids } = songsStore;
  return (
    <div className={classes.root}>
      <FiltersLayout>
        <SongList isGetSongsLoading={isGetSongsLoading} songIds={ids} />
      </FiltersLayout>
      <Checkout shouldBlockRedirect />
    </div>
  );
};

export default MainSongList;
